import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=013a938c&scoped=true&"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=013a938c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a938c",
  null
  
)

export default component.exports